import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import {
  OwnershipTransferCustomerStep,
  MessageContent,
  PopupEnum,
  PopupMessageContent,
  RequestStatus,
} from './Constant/Constant';

export const customerValidation = createAsyncThunk('OwnershipTransferCustomer/customerValidation', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('ownershipTransferMLCustomerValidation', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});
export const idNumberAndCCValidation = createAsyncThunk('OwnershipTransferCustomer/idNumberAndCCValidation', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('idNumberAndCCValidation', [data]);

    return result.Body;
  } catch (error) {
    return error;
  }
});

export const getOwnershipTransferSignatureFile = createAsyncThunk('OwnershipTransferCustomer/getOwnershipTransferSignatureFile', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('getOwnershipTransferSignatureFile', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});
export const checkOwnershipTransferSignatureFile = createAsyncThunk('OwnershipTransferCustomer/checkOwnershipTransferSignatureFile', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('getOwnershipTransferSignatureFile', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});
export const submitOwnershipTransferCustomer = createAsyncThunk(
  'OwnershipTransferCustomer/submitOwnershipTransferCustomer',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const serviceAccessForm = thunkAPI.getState().serviceAccessForm;
      const request = {
        ...data,
        ...serviceAccessForm,
      };
      const result = await ProviderManager.getProviderData('submitOwnershipTransferCustomer', request);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);

const initialState = {
  currentStep: '',
  currentPopUp: '',
  currentPopupData: null,
  showPopup: false,
  customerPhoneNumber: '',
  customerOrgId: '',
  customerIdNumber: '',
  requestStatus: '',
  fuNumber: '',
  requestId: '',
  currentEquipmentObligations: [],
  cellcomDu: false,
  transferCellcomDu: false,
  futureAbroadPackage: false,
  generalMessage: null,
  selectedPricePlan: null,
  signatureFile: {
    url: '',
    isSigned: false,
    guid: ''
  },
  subscriberAddress: {
    city: '',
    street: '',
    houseNum: '',
    apartmentNum: '',
  },
  subscriberPersonalData: {
    firstName: '',
    lastName: '',
    email: '',
  },
  customerValidated: false,
  collaborationApproval: false,
};

const OwnershipTransferCustomerSlice = createSlice({
  name: 'OwnershipTransferCustomer',
  initialState: initialState,

  reducers: {
    resetState: (state, action) => initialState,

    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    setCustomerData: (state, action) => {
      state.customerPhoneNumber = action.payload.phoneNumber;
      state.customerOrgId = action.payload.orgId;
      state.customerIdNumber = action.payload.idNumber;
    },
    setShowPopUp: (state, action) => {
      if (!action.payload) {
        state.currentPopUp = '';
        state.currentPopupData = null;
      }
      state.showPopup = action.payload;
      return state;
    },
    setCurrentPopUp: (state, action) => {
      state.showPopup = true;
      state.currentPopUp = action.payload.currentPopUp;
      if (action.payload.currentPopupData) {
        state.currentPopupData = action.payload.currentPopupData;
      }

      return state;
    },

    setSelectedPricePlan: (state, action) => {
      state.selectedPricePlan = action.payload;
    },

    saveToHistory: (state, action) => {
      return state;
    },
    setGeneralMessage: (state, action) => {
      state.generalMessage = action.payload;
    },

    setSubscriberAddress: (state, action) => {
      state.subscriberAddress.city = action.payload.city;
      state.subscriberAddress.street = action.payload.street;
      state.subscriberAddress.houseNum = action.payload.houseNum;
      state.subscriberAddress.apartmentNum = action.payload.apartment;
      state.subscriberAddress.zipCode = action.payload.zipCode;
    },
    setSubscriberPersonalData: (state, action) => {
      if (action.payload.firstName !== undefined) {
        state.subscriberPersonalData.firstName = action.payload.firstName;
      }
      if (action.payload.lastName !== undefined) {
        state.subscriberPersonalData.lastName = action.payload.lastName;
      }
      if (action.payload.email !== undefined) {
        state.subscriberPersonalData.email = action.payload.email;
      }
    },
    setTransferCellcomDu: (state, action) => {
      state.transferCellcomDu = action.payload;
    },
    setCollaborationApproval: (state, action) => {
      state.collaborationApproval = action.payload;
    },
    setFileSigned: (state, action) => {
      state.signatureFile.isSigned = action.payload;
    },
  },
  extraReducers: {
    [customerValidation.pending]: (state) => {
      state.customerValidated = false;
      state.equipmentObligations = [];
      state.futureAbroadPackage = false;
    },
    [customerValidation.fulfilled]: (state, action) => {
      if (action.payload?.isAxiosError || action.payload.errorCode || !action.payload.success) {

        const message = action.payload.message?.trim() || '';
        if (message === 'AccountNotFound') {
          state.generalMessage = MessageContent.AccountError;
        }
        else if (message === 'InvalidSubStatus') {
          state.generalMessage = MessageContent.ErrorSubStatus;
        }
        else if (message === 'InvalidNPStatus') {
          state.generalMessage = MessageContent.AccountError;
        }
        else if (message === 'Abroad') {
          state.generalMessage = MessageContent.AbroadError;
        }
        else if (message === RequestStatus.Expired) {
          state.generalMessage = MessageContent.LinkExpired;
        }
        else if (message === RequestStatus.TransferredForManualProcessing) {
          state.fuNumber = action.payload.fuNumber;
          state.generalMessage = MessageContent.ManualProgress;
        }
        else {
          state.generalMessage = MessageContent.GeneralError;
        }

        state.currentStep = OwnershipTransferCustomerStep.GeneralMessage;
        return state;

      }

      state.requestStatus = action.payload.message;
      state.requestId = action.payload.requestId;
      state.cellcomDu = action.payload.cellcomDu;
      state.subscriberPersonalData.firstName = action.payload.customerFirstName;
      state.subscriberPersonalData.lastName = action.payload.customerLastName;
      state.customerValidated = true;
      if (action.payload.futureAbroadPackage === true) {
        state.futureAbroadPackage = true;
      }
      if (action.payload.equipmentObligations?.length > 0) {
        state.currentEquipmentObligations = action.payload.equipmentObligations;
      }
      if (action.payload.message == RequestStatus.SignedAwaitingForJoin) {
        state.signatureFile.isSigned = true;
      }
      state.currentStep = OwnershipTransferCustomerStep.SelectPackage;
    },
    [getOwnershipTransferSignatureFile.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && action.payload.isSuccess) {

        state.signatureFile.url = action.payload.signUrl;
        state.signatureFile.guid = action.payload.fileGuid;
        state.currentStep = OwnershipTransferCustomerStep.AddressForm;
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferCustomerStep.GeneralMessage;
      }

    },
    [checkOwnershipTransferSignatureFile.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && action.payload.isSuccess) {
        state.signatureFile.isSigned = action.payload.isSigned;
      }
    },
    [submitOwnershipTransferCustomer.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.boolean) {
          if (!action.payload.param) {
            state.generalMessage = MessageContent.OwnershipTransferSuccess;
          } else {
            state.generalMessage = MessageContent.FormSendSuccess;
            state.fuNumber = action.payload.param;
          }
        } else {
          state.generalMessage = MessageContent.GeneralError;
        }
      } else {
        state.generalMessage = MessageContent.GeneralError;
      }
      state.currentStep = OwnershipTransferCustomerStep.GeneralMessage;
    },
  },
});

export const {
  resetState,
  setCurrentStep,
  setCurrentPopUp,
  setShowPopUp,
  saveToHistory,
  setGeneralMessage,
  setSubscriberAddress,
  setSubscriberPersonalData,
  setCustomerData,
  setSelectedPricePlan,
  setTransferCellcomDu,
  setCollaborationApproval,
  setFileSigned
} = OwnershipTransferCustomerSlice.actions;

export default OwnershipTransferCustomerSlice.reducer;
